var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00424 7C6.09196 7 6.17543 6.98241 6.25607 6.94577C6.33671 6.9106 6.40745 6.85929 6.46687 6.79187L11.8133 1.11683C11.9378 0.987855 12 0.835427 12 0.659548C12 0.534966 11.9717 0.423569 11.9165 0.322438C11.8614 0.222773 11.7864 0.14363 11.6916 0.086469C11.5968 0.0293082 11.4907 0 11.3704 0C11.2007 0 11.0507 0.0615606 10.922 0.186142L5.63076 5.78936H6.36926L1.07805 0.186142C0.953549 0.0615606 0.803578 0 0.629562 0C0.509307 0 0.403215 0.0293082 0.308426 0.086469C0.213637 0.14363 0.138642 0.222773 0.0834661 0.322438C0.0282904 0.422103 0 0.534966 0 0.659548C0 0.750419 0.0155575 0.835424 0.0480971 0.913104C0.0806366 0.990784 0.125906 1.06261 0.186741 1.12417L5.53313 6.79187C5.67319 6.93111 5.82881 7 6.00424 7Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelector);
export default __webpack_public_path__ + "static/media/selector.9135598f4e0fcf2bc1152c57b7ca7e00.svg";
export { ForwardRef as ReactComponent };